import React from 'react';
import { MEETING_STAGE } from '../AuthorMeeting';

export const AuthorNav = ({stage, meeting})=>{
    const hasCover = (meeting.cover!==null && meeting.cover!=='');
    const hasCard = (meeting.bookCard!==null && meeting.bookCard.length>0);
    return (
        <div className="inner meetingNavigation">
            { hasCover &&
            <>
                <div className={`nav_item puzzle ${stage>=MEETING_STAGE.PUZZLE?'active':''} ${stage>MEETING_STAGE.PUZZLE?'previous':''} ${stage===MEETING_STAGE.PUZZLE?'present':''}`}>함께해요</div>
                <div className={`nav_item cover ${stage>=MEETING_STAGE.COVER?'active':''} ${stage>MEETING_STAGE.COVER?'previous':''} ${stage===MEETING_STAGE.COVER?'present':''}`}>상상해요</div>
            </>
            }
            { hasCard && 
                <div className={`nav_item card ${stage>=MEETING_STAGE.CARD?'active':''} ${stage>MEETING_STAGE.CARD?'previous':''} ${stage===MEETING_STAGE.CARD?'present':''}`}>독서카드</div>
            }
            <div className={`nav_item talk ${stage>=MEETING_STAGE.TALK?'active':''} ${stage>MEETING_STAGE.TALK?'previous':''} ${stage===MEETING_STAGE.TALK?'present':''}`}>카톡해요</div>
        </div>
    );
};